var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0228 4.66475C12.2424 4.88442 12.2424 5.24058 12.0228 5.46025L5.85799 11.625L12.0228 17.7898C12.2424 18.0094 12.2424 18.3656 12.0228 18.5852C11.8031 18.8049 11.4469 18.8049 11.2273 18.5852L4.66475 12.0227C4.44508 11.803 4.44508 11.4469 4.66475 11.2273L11.2273 4.66475C11.4469 4.44508 11.8031 4.44508 12.0228 4.66475Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.824 4.66475C19.0437 4.88442 19.0437 5.24058 18.824 5.46025L12.6592 11.625L18.824 17.7898C19.0437 18.0094 19.0437 18.3656 18.824 18.5852C18.6043 18.8049 18.2481 18.8049 18.0285 18.5852L11.466 12.0227C11.2464 11.803 11.2464 11.4469 11.466 11.2273L18.0285 4.66475C18.2481 4.44508 18.6043 4.44508 18.824 4.66475Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeft);
export default __webpack_public_path__ + "static/media/doubleLeft.f5c3ee0763746c388aff26dcfb14f32b.svg";
export { ForwardRef as ReactComponent };